'use client';

import GuideHero from '@/components/GuideHero/GuideHero';
import IntegrationSteps from '@/components/IntegrationSteps/IntegrationSteps';
import styles from './page.module.css';

export default function IntegrationGuideClient() {
  return (
    <main id="main-content" className={styles.page}>
      <GuideHero />
      <IntegrationSteps />
    </main>
  );
}
